import script from "./RecordingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordingPage.vue?vue&type=script&setup=true&lang=ts"

import "./RecordingPage.vue?vue&type=style&index=0&id=54da0f2c&lang=css"

const __exports__ = script;

export default __exports__